import { Component, EventEmitter, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, FormControl } from '@angular/forms';
import { DestroyableComponent } from '../../base/destroyable.component';
import { takeUntil } from 'rxjs';

@Component({
	selector: 'tvcore-checkbox',
	templateUrl: './checkbox.component.html',
	styleUrls: ['./checkbox.component.scss'],
	standalone: false,
})
export class CheckboxComponent extends DestroyableComponent implements OnInit, OnChanges {
	@Input()
	bgInherit: boolean = false;
	@Input()
	disabled: boolean = false;
	@Input()
	name: string;
	@Input()
	radio: boolean = false;
	@Input()
	showErrors: boolean = false;
	@Input()
	selected: boolean | 'inter' = false;
	@Input()
	theme: 'blue' | 'green' = 'blue';
	@Input()
	notifyEnabled: boolean = false;
	@Output()
	toggle: EventEmitter<boolean> = new EventEmitter<boolean>();

	control: FormControl | null;

	constructor(@Optional() private controlContainer: ControlContainer) {
		super();
	}

	ngOnInit() {
		this.control = this.controlContainer?.control?.get(this.name) as FormControl;

		if (!this.control) {
			this.control = new FormControl(this.selected);
			this.control.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe((value) => this.toggle.emit(value));

			if (this.disabled) {
				this.control.disable();
			}
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (!this.controlContainer) {
			const change = changes['selected'];

			if (!change.firstChange) {
				this.control?.setValue(change.currentValue);
			}
		}

		// if (this.notifyEnabled && !changes['selected'].firstChange) {
		// 	const selected = changes['selected'].currentValue;
		// 	this.control?.setValue(selected, { emitEvent: false });
		// }
	}

	hasError(): boolean {
		return this.showErrors && this.control?.value !== true;
	}

	isActive(): boolean {
		return this.control?.value === true;
	}

	isInter(): boolean {
		return this.control?.value === 'inter';
	}
}
